module.exports = __webpack_public_path__ + "img/7fff0c9a-d29f-4c7a-87c2-266c244a67be.a2d4430e.webp";